import React from 'react';
import { Card, MetaCard } from './styles';
import { Image } from 'antd';


export const CardProduct = ({ urlImage, title, description, onClick }) => {

    return (
        <Card
            hoverable
            onClick={onClick}
            cover={<img alt="example" src={urlImage} />}
        >
            <MetaCard title={title} description={description}/>
        </Card>
    )
  }